import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'

/**
 * @param  trigger      触发该转换的实例
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  padfName     PDF文件生成后的文件名字
 * */
function downloadPDF(trigger, ele, pdfName) {
  if (trigger.loading) {
    return
  } else {
    trigger.loading = true
  }

  setTimeout(() => {
    let eleW = ele.offsetWidth // 获得该容器的宽
    let eleH = ele.offsetHeight // 获得该容器的高
    let eleOffsetTop = ele.offsetTop // 获得该容器到文档顶部的距离
    let eleOffsetLeft = ele.offsetLeft // 获得该容器到文档最左的距离
    let scale = window.devicePixelRatio

    var canvas = document.createElement('canvas')
    var abs = 0

    let win_in = document.documentElement.clientWidth || document.body.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
    let win_out = window.innerWidth // 获得当前窗口的宽度（包含滚动条）

    if (win_out > win_in) {
      // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
      abs = (win_out - win_in) / 2 // 获得滚动条宽度的一半
      // console.log(a, '新abs');
    }
    canvas.width = eleW * scale // 将画布宽&&高放大两倍
    canvas.height = eleH * scale

    var context = canvas.getContext('2d')
    context.scale(scale, scale)
    context.translate(-eleOffsetLeft - abs, -eleOffsetTop)

    html2canvas(ele, {
      dpi: 300,
      scale: scale * 1.3,
      allowTaint: false,
      background: '#ffffff',
      // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
      useCORS: true, //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      windowHeight: (eleH + ele.scrollHeight) * scale,
      // 回调
      onclone(html) {
        var modalBody = html.querySelector('.ant-modal-body')

        if (modalBody) {
          // 加粗字体
          modalBody.classList.add('font-bold')

          // 去掉placeholder
          modalBody.querySelectorAll('[placeholder]').forEach(element => {
            element.setAttribute('placeholder', '')
          })

          // 添加专属class
          modalBody.classList.add('htmlToPdf')

          // hong@20221012 改为通过htmlToPdf整体控制css
          //// 处理loading
          //if (modalBody.querySelector('.ant-spin-spinning')) {
          //  modalBody.querySelector('.ant-spin-spinning').style.setProperty('display', 'none')
          //}
          //if (modalBody.querySelector('.ant-spin-container')) {
          //  modalBody.querySelector('.ant-spin-container').classList.remove('ant-spin-blur')
          //}

          //// 处理descriptions的标题渐变色
          //var textNodes = modalBody.querySelectorAll('.ant-descriptions-title')
          //if (textNodes && textNodes.length > 0) {
          //  textNodes.forEach(dom => {
          //    dom.style.setProperty('background', 'none')
          //  })
          //}

          //// 处理inlineNote
          //var inLineNoteNodes = modalBody.querySelectorAll('.inlineNote')
          //if (inLineNoteNodes && inLineNoteNodes.length > 0) {
          //  inLineNoteNodes.forEach(dom => {
          //    dom.classList.remove('inlineNote')
          //  })
          //}

          //var operationComment = modalBody.querySelectorAll('.operation-comment')
          //if (operationComment && operationComment.length > 0) {
          //  operationComment.forEach(dom => {
          //    dom.style.setProperty('background', 'var(--color-primary-6)')
          //  })
          //}
        }
      },
      removeContainer: true
    })
      .then(canvas => {
        // 纵向打印
        if (XEUtils.divide(canvas.width, canvas.height) < XEUtils.divide(297, 210)) {
          var printW = 210
          var printH = 297
          var topPadding = 5
          var bottomPadding = 5
          var leftPadding = 5
          var rightPadding = 5
        }
        // 横向打印
        else {
          var printW = 297
          var printH = 210
          var topPadding = 5
          var bottomPadding = 5
          var leftPadding = 5
          var rightPadding = 5
        }

        var direction = 'l' // 默认横向打印
        var size = 'a4'
        if (printW && printH) {
          size = [printW, printH]
          if (printW <= printH) {
            direction = 'p'
          } else {
            direction = 'l'
          }
        }
        var pdf = new JsPDF(direction, 'mm', size) // A4纸，纵向
        var ctx = canvas.getContext('2d')
        var a4w = printW ? printW - (leftPadding + rightPadding) : 190
        var a4h = printH ? printH - (topPadding + bottomPadding) : 277 // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
        var imgHeight = Math.floor((a4h * canvas.width) / a4w) // 按A4显示比例换算一页图像的像素高度
        var renderedHeight = 0

        while (renderedHeight < canvas.height) {
          var page = document.createElement('canvas')
          page.width = canvas.width
          page.height = Math.min(imgHeight, canvas.height - renderedHeight) // 可能内容不足一页

          // 用getImageData剪裁指定区域，并画到前面建立的canvas对象中
          page
            .getContext('2d')
            .putImageData(
              ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)),
              0,
              0
            )
          pdf.addImage(
            page.toDataURL('image/jpeg', 1.0),
            'JPEG',
            leftPadding,
            topPadding,
            a4w,
            Math.min(a4h, (a4w * page.height) / page.width)
          ) // 添加图像到页面，保留10mm边距

          renderedHeight += imgHeight
          if (renderedHeight < canvas.height) {
            pdf.addPage()
          } // 若是后面还有内容，添加一个空页
          page.remove()
        }
        const link = window.URL.createObjectURL(pdf.output('blob'))
        window.open(link)
      })
      .finally(() => {
        trigger.loading = false
      })
  }, 1)
}
export default {
  downloadPDF
}

